import type {
  HubDataset,
  HubExamplePickingStrategy,
} from '@robovision/hub'
import { naturalSort } from '@robovision/rvai-utils'
import { Class } from '~domain/Class'


export interface DatasetParams {
  artifactId?: string
  classes?: Class[]
  createdAt: Date
  creatorId?: string
  datapoolId: string
  description: string
  exampleDefinitionId: string
  examplePickingStrategy: HubExamplePickingStrategy
  id: string
  logicalType?: string
  name: string
  projectId: string
  sourceJobId?: string
  splitId?: string
  testSet: boolean
}

export class Dataset {
  static readonly modelName = 'Dataset'

  public readonly artifactId?: string
  public readonly classes?: Class[]
  public readonly createdAt: Date
  public readonly creatorId?: string
  public readonly datapoolId: string
  public readonly description: string
  public readonly exampleDefinitionId: string
  public readonly examplePickingStrategy: HubExamplePickingStrategy
  public readonly id: string
  public readonly logicalType?: string
  public readonly name: string
  public readonly projectId: string
  public readonly sourceJobId?: string
  public readonly splitId?: string
  public readonly testSet: boolean

  public constructor (params: DatasetParams) {
    this.artifactId = params.artifactId
    this.classes = params.classes
    this.createdAt = params.createdAt
    this.creatorId = params.creatorId
    this.datapoolId = params.datapoolId
    this.description = params.description
    this.exampleDefinitionId = params.exampleDefinitionId
    this.examplePickingStrategy = params.examplePickingStrategy
    this.id = params.id
    this.logicalType = params.logicalType
    this.name = params.name
    this.projectId = params.projectId
    this.sourceJobId = params.sourceJobId
    this.splitId = params.splitId
    this.testSet = params.testSet
  }

  public static fromResponse (data: HubDataset) {
    return new Dataset({
      artifactId: data.artifactId,
      classes: data.classes
        ? Class.fromLiveClasses(data.classes, true)
          .sort((a: Class, b: Class) => naturalSort(a.name, b.name))
        : undefined,
      createdAt: new Date(data.createdAt),
      creatorId: data.creatorId,
      datapoolId: data.datapoolId,
      description: data.description,
      exampleDefinitionId: data.exampleDefinitionId,
      examplePickingStrategy: data.examplePickingStrategy,
      id: data.id,
      logicalType: data.logicalType,
      name: data.name,
      projectId: data.projectId,
      sourceJobId: data.sourceJobId,
      splitId: data.splitId ?? undefined,
      testSet: data.testSet,
    })
  }
}
